<template>
  <div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Sub Category"
      id="admin_view_sub_category_details"
    ></CardedSectionHeader>
    <div class="pt-4 pb-4 white text-right pr-8">
      <v-btn
        :to="
          '/admin/categories/sub_categories/view/' + $route.params.id + '/edit'
        "
        small
        rounded
        class="mr-4"
        outlined
        color="warning"
      >
        <v-icon left>mdi-pen</v-icon>Edit Sub Category
      </v-btn>
      <v-btn
        :to="
          '/admin/categories/sub_categories/view/' +
          $route.params.id +
          '/delete'
        "
        small
        rounded
        class="mr-4"
        outlined
        color="red"
      >
        <v-icon left>mdi-times</v-icon> Remove Sub Category
      </v-btn>
    </div>
    <CardedDisplay>
      <ViewHeader
        :title="sub_category.name"
        :icon="sub_category.icon"
        :img_src="sub_category.thumb_nail"
        :facts="view_header_facts"
        :description="sub_category.description"
      ></ViewHeader>
    </CardedDisplay>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Businesses In This Sub Category"
      id="admin_view_sub_category_businesses"
    ></CardedSectionHeader>
    <CardedDisplay>
      <CardedTable
        :items="businesses"
        :headers="business_headers"
        :show_description="true"
      >
        <template v-slot:[`item.owner`]="{ item }">
          {{ item.user.first_name }} {{ item.user.last_name }}
        </template>
        <template v-slot:[`item.category`]="{}">
          <v-icon v-if="sub_category.category">{{
            sub_category.category.icon
          }}</v-icon>
          {{ sub_category.category ? sub_category.category.name : "" }}
        </template>
        <template v-slot:description>
          <p class="text-left ml-4 mr-4">
            This sub category has {{ businesses.length }} businesses
          </p>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            @click="view_business(item)"
            x-small
            rounded
            text
            color="success"
          >
            <v-icon>mdi-eye</v-icon>
          </v-btn>
        </template>
      </CardedTable>
    </CardedDisplay>
  </div>
</template>

<script>
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import ServerClient from "../../../lib/ServerClient";
import ViewHeader from "../../../components/ViewHeader";
import CardedDisplay from "../../../components/CardedDisplay";
import CardedTable from "../../../components/CardedTable";
export default {
  name: "AdminSubCategoriesView",
  components: {
    CardedSectionHeader,
    ViewHeader,
    CardedDisplay,
    CardedTable,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      sub_category: {
        id: 0,
        name: "",
        category: null,
        thumb_nail: "",
        description: "",
      },
      businesses: [],
      business_headers: [
        { text: "Name", value: "name" },
        { text: "Category", value: "category.name" },
        {
          text: "Phone Number",
          value: "office_phone_number1",
          sortable: false,
        },
        { text: "Owner", value: "owner", sortable: false },
        { text: "Description", value: "description", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],
    };
  },
  methods: {
    view_business(business) {
      this.$router.push("/admin/businesses/view/" + business.id);
    },
  },
  computed: {
    view_header_facts() {
      var facts = [
        {
          text: "Category:",
          val: this.sub_category.category
            ? this.sub_category.category.name
            : "",
        },
        {
          text: "Top Category:",
          val:
            this.sub_category.category &&
            parseInt(this.sub_category.category.is_top_category) == 1
              ? "Yes"
              : "No",
        },
        {
          text: "Top Category Level:",
          val: this.sub_category.category
            ? this.sub_category.category.top_category_level
            : 0,
        },
      ];
      return facts;
    },
  },
  mounted() {
    var sub_category_id = this.$route.params.id;
    this.$emit("set-page-attributes", {
      title: "Sub Category Details",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Categories",
          disabled: false,
          href: "/admin/categories",
        },
        {
          text: "Subs",
          disabled: false,
          href: "/admin/categories/sub_categories/list",
        },
        {
          text: "View",
          disabled: true,
          href: "/admin/categories/sub_categories/view/" + sub_category_id,
        },
      ],
    });
    this.$emit("on-show-loader");
    ServerClient.Categories.get_sub_category(
      {
        id: sub_category_id,
        is_admin: true,
      },
      (res) => {
        this.$emit("on-hide-loader");
        this.sub_category = res.sub_category;
        this.businesses = res.businesses;
      },
      (errors) => {
        this.$emit("on-hide-loader");
        console.log(
          "Errors while loading sub category details on admin",
          errors
        );
      }
    );
  },
};
</script>